import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { SocketContext } from './socketio';

const notification = new Audio('/island/signin.mp3');

const useNewUserNotification = (sodabit_id) => {
  const { socket, connected } = useContext(SocketContext);
  const alreadySetSodabit = useRef(false);

  useEffect(() => {
    if (!(sodabit_id && connected)) {
      return;
    }

    if (alreadySetSodabit.current) {
      return;
    }

    alreadySetSodabit.current = true;
    socket.emit('set-sodabit', sodabit_id);
  }, [connected, socket, sodabit_id]);

  useEffect(() => {
    if (!connected) {
      return;
    }

    const cb = (other_sodabit_id) => {
      notification.play();
    };

    socket.on('new-user', cb);

    return () => socket.off('new-user', cb);
  }, [connected, socket, sodabit_id]);
};

export default useNewUserNotification;
